import { DATE_RANGE_TIME_FORMAT } from 'constants/reporting';
import dayjs from 'dayjs';
import { IQuickRange } from 'components/DateRangeFilter/IQuickRange';

import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

const getDateRange = (range: IQuickRange | undefined) => {
  if (!range) return { from: undefined, to: undefined };

  const to = new Date();
  const from = dayjs()
    .subtract(range.value, range.unit as any)
    .toDate();
  return { from, to };
};

const formatSeconds = (seconds: number): string => {
  if (seconds < 0) return '0s';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const parts = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }

  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }

  if (remainingSeconds > 0 || parts.length === 0) {
    parts.push(`${remainingSeconds}s`);
  }

  return parts.join(' ');
};

const formatNumbersToTime = (numbers: number[]) => {
  return numbers
    .map((num) => {
      return num.toString().padStart(2, '0');
    })
    .join(':');
};

const formatSecondsToTime = (seconds: number): string => {
  if (seconds < 0) return '00:00:00';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  return formatNumbersToTime([hours, minutes, remainingSeconds]);
};

const formatUrlDateWithTimezone = (date?: Date) => {
  if (!date) return '';
  return encodeURIComponent(dayjs(date).format(DATE_RANGE_TIME_FORMAT));
};

const getTimeDiffFromStartTime = (timestamp: number, startTime: string) => {
  const callStartTimestamp = dayjs(startTime).valueOf();
  const diffMs = timestamp - callStartTimestamp;
  const diffDuration = dayjs.duration(diffMs);
  const minutes = diffDuration.minutes();
  const seconds = diffDuration.seconds();

  return formatNumbersToTime([minutes, seconds]);
};

export {
  getDateRange,
  formatSecondsToTime,
  formatSeconds,
  formatUrlDateWithTimezone,
  getTimeDiffFromStartTime,
};
